import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { UiCard } from 'src/components/UI/Card';

import { UiMereLabel } from 'src/components/UI/UiMereLabel';

export const CheckoutConfirmationBidExplainerText = memo(() => {
  const { t } = useTranslation();

  return (
    <UiCard>
      <p className="no-margin">
        <UiMereLabel className="text-left">{t('checkout.confirmation.bidExplainerText')}</UiMereLabel>
      </p>
    </UiCard>
  );
});
